import request from '@/utils/request'
import downloadData from '@/utils/download'
// 工事（作業）実施状況情報取得(協力会社)
export function workImplementStatusInfo(implementStatusId) {
  return request({
    url: `/api/workImplementStatus/found/${implementStatusId}`,
    method: 'get',
  })
}
// 工事実施状況情報更新(協力会社)
export function update(data) {
  return request({
    url: `/api/workImplementStatus/partner/update`,
    method: 'post',
    data,
  })
} // 資料連携-共有資料-ダウンロード
export function dlnDownload(data) {
  // downloadData.resource(`/api/workImplementStatus/partner/download`, data)
  downloadData.resource(`/api/scReport/relation/download`, data)
}
// 資料連携-共有資料リスト
export function listFiles(data) {
  return request({
    // url: `/api/workImplementStatus/partner/listFiles`,
    url: `/api/scReport/relation/listFiles`,
    method: 'post',
    data,
  })
}
